module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-1",
    attrs: {
      "id": "untitled-1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "untitled-111"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal-229-0-override4"
  }, [_c('span', {
    staticClass: "no-style-override4"
  }, [_c('br', {
    staticClass: "calibre1"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "chapter",
    attrs: {
      "id": "toc-anchor"
    }
  }, [_vm._v("Preface")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph-236-0-override"
  }, [_c('span', {
    staticClass: "character-style-5-214-0-filtered"
  }, [_vm._v("I")]), _vm._v("n 2009, my book "), _c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("The Bundy Murders: A Comprehensive History")]), _vm._v(" was published by McFarland & Company. It’s an in-depth biography of the infamous serial sex killer Ted Bundy. Published 20 years after Bundy was put to death, it was the first biography of the killer to be published in many years. The book contains new information about the case, sheds new light on a number of the murders, and it continues to be well received by those fascinated by Bundy’s reign of terror. ")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("Bundy, who became a successful killer through meticulous planning and execution of his crimes, operated in at least seven states, and during his years of murder – 1974 through most of 1975, and then again in 1978--managed to kill more than 30 women. Indeed, that number may be higher, and may in fact exceed 50, as there were murders Bundy refused to talk about. His victims were mostly young women, but he murdered teenage and preteen girls as well, and these younger victims he did not like to talk about.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("Bundy’s method of killing was mostly consistent, although he could deviate from his norm at any moment. Many women were whacked on the head with a crowbar, and almost all were finished off through strangulation while Bundy had sex with them from behind. Necrophilia in various forms was usually a part of the murders, too, especially if Bundy had the time to spend with them after they died or if he was able to return to the remains at a later date. This, of course, was not always possible. One of the most bizarre aspects of this sexual deviance is that while living in Washington (where the murders began), Bundy kept as many as four women’s heads in his apartment at a rooming house where he was living. That he used these heads for sexual pleasure, there is little doubt. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("So this retrospective look–a “back story” if you will, into the life of America’s most diabolical serial killer--will not be another biography. Rather, it’s a deeper look into his crimes across various states containing new and interesting information about the case; a case that to this day still has a sense of mystery surrounding it. It is, in fact, a search for additional truth and, as such, is an excellent companion volume to")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("The Bundy Murders")]), _c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v(". ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("Within these pages you’ll read new testimony from those who knew the killer, from friends of the victims, and from others who were involved in this story one way or another. Indeed, this book records for history many important voices that would otherwise go silent after the passage of time.  In my view, to not add these voices to the record would be a crime.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("It also includes new and previously unpublished stories from some of Bundy’s Mormon friends, whom the killer met after he moved to Utah to attend law school. He sought out their friendship, proclaiming an interest in the Church of Jesus Christ of Latter-day Saints. They, of course, welcomed him with open arms, believing him to be a good and honest man. But like those who “knew” Bundy in his home state of Washington, they would later be shocked to learn of Bundy’s true inner drives and intentions. Bundy’s monstrous desires and cravings to kill and mutilate women were not easy for many of his friends to believe, and some would not accept that these dark accusations against him were true until the end, when Bundy finally started to come clean.")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("I must also note that the bulk of the testimony you’ll be reading in this book (new interviews and the written record) comes from people from Washington and Utah, as these are the two states where Ted Bundy put down roots and developed relationships with many people. But I have new interviews and testimony as well from California, Oregon, Idaho, and Colorado, as well as additional material that will enlighten the reader with facts usually seen only by those conducting in-depth archival research into the Bundy case.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("On top of all this I have also taken a closer look at some of the murders, their locations, and some oddities and new discoveries that weren’t in the first book, and there are photographs of all of those sites. It will, without a doubt, be a most fascinating excursion into Ted Bundy and his unequaled time of terror.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("A personal note: When I finished")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("The Bundy Murders")]), _c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v(", at 5:21 a.m., July 17, 2008 (yes, I wrote it down), I was exhausted emotionally and physically from my 2½-year marathon into the life of Ted Bundy. By the time I typed that last word, I felt like I knew the killer better than some members of my own extended family. I also discovered along the way (and in the years since) that the victims became a part of my life. There isn’t a day that goes by that I don’t think about them and the man who took their lives. Not to sound overly dramatic, but it is as if the case has been indelibly printed deep within the recesses of my being, and for the rest of my life it will be there. And frankly, that’s fine with me. It goes with the territory.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("Once the book was published, I was more than willing to answer questions about the case, and I even knocked out the occasional article. But the thought of writing another book where the focus would be Ted Bundy? Not a chance! That was out. I couldn’t imagine delving into that dark world once again. So when a writer asked me a couple of years ago to co-author a book about the killer, where we’d be exploring")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("possible")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("new aspects of the case, I politely said no. And then, in the spring of 2015, I spoke with someone closely connected to the investigation, and discovered they were having significant medical problems. Understanding that time waits for no one (it’s been 41 years since Bundy began his murderous career), I knew it was time to seek out people and consult the case files one more time. We owe it to future generations to record now those voices still out there who are willing to talk. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("The result of that decision is the book you’re about to read. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override5"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("Louisville, Kentucky")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override5"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("Fall 2015")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_14"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7743fc75","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Preface.vue
// module id = 78
// module chunks = 0